import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { ApiRecipientConstants } from "../../../../../shared/constants/api-constants/api-recipient.constants";
let RecipientSettingsService = class RecipientSettingsService {
    http;
    constructor(http) {
        this.http = http;
    }
    getOrganisationInformation(organisationParam, endPointUrl) {
        const params = { $expand: organisationParam };
        return this.http.get(endPointUrl, { params })
            .pipe(map(response => {
            return response.organisations;
        }));
    }
    getData(params, endPointUrl) {
        return this.http.get(endPointUrl, { params })
            .pipe(map(recipientResponse => {
            return recipientResponse;
        }));
    }
    getRecipientsByGroup(params) {
        return this.http.post(`${ApiRecipientConstants.URL}/${ApiRecipientConstants.FUNCTION_GET_RECIPIENTS_BY_GROUP}`, params);
    }
    deleteData(recipientID, endPointUrl) {
        return this.http.delete(`${endPointUrl}/${recipientID}`)
            .pipe(map(recipientResponse => {
            return recipientResponse;
        }));
    }
    postData(objectToPost, endPointUrl) {
        return this.http.post(endPointUrl, objectToPost)
            .pipe(map(recipientResponse => {
            return recipientResponse;
        }));
    }
    patchData(objectToPatch, endPointUrl) {
        return this.http.patch(endPointUrl, objectToPatch)
            .pipe(map(recipientResponse => {
            return recipientResponse;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
RecipientSettingsService = __decorate([
    Injectable({
        providedIn: "root"
    })
], RecipientSettingsService);
export { RecipientSettingsService };
